import { render, staticRenderFns } from "./StepItem.vue?vue&type=template&id=1f067dbe&scoped=true&lang=true&"
import script from "./StepItem.vue?vue&type=script&lang=js&"
export * from "./StepItem.vue?vue&type=script&lang=js&"
import style0 from "./StepItem.vue?vue&type=style&index=0&id=1f067dbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f067dbe",
  null
  
)

export default component.exports